var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81694 0.995558C8.06102 1.23964 8.06102 1.63536 7.81694 1.87944L4.69194 5.00444C4.44786 5.24852 4.05214 5.24852 3.80806 5.00444L0.683058 1.87944C0.43898 1.63536 0.43898 1.23964 0.683058 0.995558C0.927136 0.751481 1.32286 0.751481 1.56694 0.995558L4.25 3.67862L6.93306 0.995558C7.17714 0.751481 7.57286 0.751481 7.81694 0.995558Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarat);
export default __webpack_public_path__ + "static/media/Carat.4af0796069565f406a49d30d1cbac813.svg";
export { ForwardRef as ReactComponent };